import { answeredMapper, calidadDatosMapper, invalidMapper, porcRespuestasMapper } from "../dashHelper"
import { getCommonWidget } from '../dashWidgetHelper'
import { getLineDetailedRadar, radialMapperByIndicator } from "../widgetsLibrary/widgetsLine"
import { commonWidgets, getCmID, jacGaugeCount10NumberMapper, getJacCustomerJourney } from "./commonWidgetsJac"

const cjMapper =  (data: any) : any => {
return Object.keys(data).flatMap((key) => {
               
           var  value  = jacGaugeCount10NumberMapper(data[key]) //ojo aca, estaba el de base 10 para kox
            var label =  `widgets.${key}`
            return {
                value: value,
                name: key,
                label: label
            }
            
        });
        }


export default {
    title: "ISD Dashboard",
    description: "ISD",
    backgroundClassName: (filters: any) => {
        return 'epsilon-hero-bg'
    },
    widgets: (filters: FiltersUI) => [
        
          getLineDetailedRadar({
             mainIndicator: 'CSATISD',
             filters: filters,
             geoGrupedCondition: {0:{group:'formattedMonth,geoLocation', level:2},
                                  29:{group:'formattedMonth,geoLocation', level:2},
                                  default:{group:'formattedMonth,logicalLocation', level:3},
                                 },
                           
             radialIndicators: [
                 'duenos_sat_comunicacion',  //FIX ver que pregunta va aca ya que duenos no tiene satisfaccion
                 'director_marca_sat_experiencia',
                 'gerente_general_sat_experiencia',
                 'gerente_postventa_sat_experiencia',
                 'gerente_ventas_sat_experiencia'
             ],
             radialType: 'byIndicator',
             position: [0, 0],
             size: [4, 3],
             title: 'widgets.snByGrupo',
             criticalMomentInclude: [getCmID('ISD')],
             extras:{
                groupByLevel: 3
             },
             extraConfigs: {
                 backgroundColor: 'transparent',
                 theme: 'dark',
                 showRadialChart: true,
                 initialVisibleChart: 1,
                 maxValue: 100,
             },
             groupByLevel: 2,
             useNormalizedRadial: false,
             indicatorsNames: {
                 'duenos_sat_comunicacion': 'Dueños',
                 'director_marca_sat_experiencia': 'Directores de Marca',
                 'gerente_general_sat_experiencia': 'Gerente General',
                 'gerente_postventa_sat_experiencia': 'Gerente Postventa',
                 'gerente_ventas_sat_experiencia': 'Gerente Venta',
             },
         }),
         


        {
            title: 'labels.duenos',
            type: 'label',
            size: [4, 1],
            config: { color: '#B7AADC' },
        },

        getJacCustomerJourney({
            id: 'cj-sucursal-duenos-1',
            title: ' ',
            size: [4, 2],
            mapper: cjMapper,
            indicators: [
                { name: 'duenos_sat_comunicacion', formula: 'count-number' },
                //{ name: 'duenos_corporativo_estrategia', formula: 'count-number' }, este es pie  si/no
                { name: 'duenos_corporativo_accesibles', formula: 'count-number' },
                { name: 'duenos_corporativo_resolucion', formula: 'count-number' },
                { name: 'duenos_corporativo_recursos', formula: 'count-number' },
                { name: 'duenos_politicas_comerciales', formula: 'count-number' },
            ],
        }),
        getJacCustomerJourney({
            id: 'cj-sucursal-duenos-2',
            title: ' ',
            size: [4, 2],
            mapper: cjMapper,
            indicators: [

                { name: 'duenos_sat_disponibilidad_vehiculos', formula: 'count-number' },
                { name: 'duenos_sat_disponibilidad_piezas', formula: 'count-number' },
                { name: 'duenos_corporativo_necesidades', formula: 'count-number' },
                { name: 'duenos_corporativo_decisiones', formula: 'count-number' },
            ],
        }),
        {
            title: 'labels.directores_marca',
            type: 'label',
            size: [4, 1],
            config: { color: '#B7AADC' },
        },

        getJacCustomerJourney({
            id: 'cj-sucursal-directores-marca-1',
            title: ' ',
            size: [4, 2],
            mapper: cjMapper,
            indicators: [
                { name: 'director_marca_sat_calidad', formula: 'count-number' },
                { name: 'director_marca_corporativo_vision', formula: 'count-number' },
                { name: 'director_marca_directivos_corporativo_accesible', formula: 'count-number' },
                { name: 'director_marca_corporativo_resolucion', formula: 'count-number' },
                { name: 'director_marca_sat_recursos_ventas', formula: 'count-number' },
                { name: 'director_marca_sat_recursos_postventa', formula: 'count-number' },
            ],
        }),
        getJacCustomerJourney({
            id: 'cj-sucursal-directores-marca-2',
            title: ' ',
            size: [4, 2],
            mapper: cjMapper,
            indicators: [


                { name: 'director_marca_sat_recursos_cliente', formula: 'count-number' },
                { name: 'director_marca_politicas_comerciales', formula: 'count-number' },
                { name: 'director_marca_relevancia_capacitacion', formula: 'count-number' },
                { name: 'director_marca_sat_planeacion_vehiculos', formula: 'count-number' },
                { name: 'director_marca_sat_planeacion_refacciones', formula: 'count-number' },
                { name: 'director_marca_sat_actitud_unidades', formula: 'count-number' },
            ],
        }),
        getJacCustomerJourney({
            id: 'cj-sucursal-directores-marca-3',
            title: ' ',
            size: [4, 2],
            mapper: cjMapper,
            indicators: [

                { name: 'director_marca_sat_actitud_refacciones', formula: 'count-number' },
                { name: 'director_marca_corporativo_tendencias', formula: 'count-number' },
                { name: 'director_marca_confianza_decisiones', formula: 'count-number' },
                { name: 'director_marca_sat_experiencia', formula: 'count-number' },
            ],
        }),

        {
            title: 'labels.gerente_general',
            type: 'label',
            size: [4, 1],
            config: { color: '#B7AADC' },
        },

        getJacCustomerJourney({
            id: 'cj-gerente-general-1',
            title: ' ',
            size: [4, 2],
            mapper: cjMapper,
            indicators: [
                { name: 'gerente_general_sat_comunicacion', formula: 'count-number' },
                { name: 'gerente_general_corporativo_estrategia', formula: 'count-number' },
                { name: 'gerente_general_corporativo_accesible', formula: 'count-number' },
                { name: 'gerente_general_corporativo_resolucion', formula: 'count-number' },
                { name: 'gerente_general_sat_recursos', formula: 'count-number' },
            ],
        }),
        getJacCustomerJourney({
            id: 'cj-gerente-general-2',
            title: ' ',
            size: [4, 2],
            mapper: cjMapper,
            indicators: [


                { name: 'gerente_general_politicas_comerciales', formula: 'count-number' },
                { name: 'gerente_general_relevancia_capacitacion_ventas', formula: 'count-number' },
                { name: 'gerente_general_relevancia_capacitacion_postventas', formula: 'count-number' },
                { name: 'gerente_general_relevancia_capacitacion_operativa', formula: 'count-number' },
                { name: 'gerente_general_sat_disponibilidad_vehiculos', formula: 'count-number' },
            ],
        }),
        getJacCustomerJourney({
            id: 'cj-gerente-general-3',
            title: ' ',
            size: [4, 2],
            mapper: cjMapper,
            indicators: [

                { name: 'gerente_general_sat_actitud_unidades', formula: 'count-number' },
                { name: 'gerente_general_sat_actitud_refacciones', formula: 'count-number' },
                { name: 'gerente_general_corporativo_decision', formula: 'count-number' },
                { name: 'gerente_general_confianza_decisiones', formula: 'count-number' },
                { name: 'gerente_general_sat_experiencia', formula: 'count-number' },
            ],
        }),
        {
            title: 'labels.gerente_ventas',
            type: 'label',
            size: [4, 1],
            config: { color: '#B7AADC' },
        },

        getJacCustomerJourney({
            id: 'cj-gerente-ventas-1',
            title: ' ',
            size: [4, 2],
            mapper: cjMapper,
            indicators: [
                { name: 'gerente_ventas_sat_comunicacion', formula: 'count-number' },
                { name: 'gerente_ventas_corporativo_resolucion', formula: 'count-number' },
                { name: 'gerente_ventas_corporativo_accesible', formula: 'count-number' },
                { name: 'gerente_ventas_metas', formula: 'count-number' },
                { name: 'gerente_ventas_corporativo_estrategias', formula: 'count-number' },
                { name: 'gerente_ventas_corporativo_politicas_com', formula: 'count-number' },
            ],
        }),
        getJacCustomerJourney({
            id: 'cj-gerente-ventas-2',
            title: ' ',
            size: [4, 2],
            mapper: cjMapper,
            indicators: [
                { name: 'gerente_ventas_materiales_marketing', formula: 'count-number' },
                { name: 'gerente_ventas_programas_capacitacion', formula: 'count-number' },
                { name: 'gerente_ventas_corporativo_eficiencia', formula: 'count-number' },
                { name: 'gerente_ventas_amabilidad_logistica', formula: 'count-number' },
                { name: 'gerente_ventas_corporativo_respaldo', formula: 'count-number' },
                { name: 'gerente_ventas_sat_soporte_evs', formula: 'count-number' },
            ],
        }),
        getJacCustomerJourney({
            id: 'cj-gerente-ventas-3',
            title: ' ',
            size: [4, 2],
            mapper: cjMapper,
            indicators: [
                { name: 'gerente_ventas_amabilidad_evs', formula: 'count-number' },
                { name: 'gerente_ventas_amabilidad_flotillas', formula: 'count-number' },
                { name: 'gerente_ventas_sat_soporte_flotillas', formula: 'count-number' },
                { name: 'gerente_ventas_sat_experiencia', formula: 'count-number' },
            ],
        }),
        {
            title: 'labels.gerente_postventa',
            type: 'label',
            size: [4, 1],
            config: { color: '#B7AADC' },
        },

        getJacCustomerJourney({
            id: 'cj-gerente-postventa-1',
            title: ' ',
            size: [4, 2],
            mapper: cjMapper,
            indicators: [
                { name: 'gerente_postventa_claridad_procesos', formula: 'count-number' },
                { name: 'gerente_postventa_comunicacion', formula: 'count-number' },
                { name: 'gerente_postventa_resolutivo', formula: 'count-number' },
                { name: 'gerente_postventa_temas_visita', formula: 'count-number' },
                { name: 'gerente_postventa_corporativo_recursos', formula: 'count-number' },
                { name: 'gerente_postventa_soporte_tecnico', formula: 'count-number' },
            ],
        }),
        getJacCustomerJourney({
            id: 'cj-gerente-postventa-2',
            title: ' ',
            size: [4, 2],
            mapper: cjMapper,
            indicators: [
                { name: 'gerente_postventa_actitud_soporte_tecnico', formula: 'count-number' },
                { name: 'gerente_postventa_herramientas_digitales', formula: 'count-number' },
                { name: 'gerente_postventa_equipo_garantias', formula: 'count-number' },
                { name: 'gerente_postventa_eficiencia_corporativo', formula: 'count-number' },
                { name: 'gerente_postventa_sat_capacitacion_formacion', formula: 'count-number' },
                { name: 'gerente_postventa_programas_formacion', formula: 'count-number' },
            ],
        }),
        getJacCustomerJourney({
            id: 'cj-gerente-postventa-3',
            title: ' ',
            size: [4, 2],
            mapper: cjMapper,
            indicators: [
                { name: 'gerente_postventa_sat_capacitacion_corporativo', formula: 'count-number' },
                { name: 'gerente_postventa_experiencia_amabilidad', formula: 'count-number' },
                { name: 'gerente_postventa_eficiencia_atencion_clientes', formula: 'count-number' },
                { name: 'gerente_postventa_sat_experiencia', formula: 'count-number' },
            ],
        }),
        getCommonWidget({
             commonWidgets: commonWidgets,
             name: 'rankingByTagBest',
             title: 'widgets.bestRotativasVenta',
             position: [0, 10],
             size: [2, 1],
             indicator: 'SENTIMENT',
             extras: {
               trunc: 'HALF_DOWN',
               topSize: 3,
             },
             criticalMomentInclude: [getCmID('ISD')],
           }),
           getCommonWidget({
             commonWidgets: commonWidgets,
             name: 'rankingByTagWorst',
             title: 'widgets.worstRotativasVenta',
             position: [2, 10],
             size: [2, 1],
             indicator: 'SENTIMENT',
             extras: {
               resultType: 'bottom',
               trunc: 'HALF_UP',
               bottomSize: 3,
             },
             criticalMomentInclude: [getCmID('ISD')],
           }),
           getCommonWidget({
             commonWidgets: commonWidgets,
             name: 'mapByGeos',
             title: 'Mapa de estaciones',
             position: [0, 11],
             size: [2, 2],
             indicator: 'CSATISD',
             criticalMomentInclude: [getCmID('ISD')],
           }),
           getCommonWidget({
             commonWidgets: commonWidgets,
             name: 'rankingByGeoBest',
             title: 'widgets.bestGeoLocationsPostventa',
             position: [2, 11],
             size: [1, 2],
             extraConfigs: {
               backgroundColor: '#501C78',
               titleBackgroundColor: '#88DD76'
             },
             indicator: 'CSATISD',
             criticalMomentInclude: [getCmID('ISD')],
           }),
           getCommonWidget({
             commonWidgets: commonWidgets,
             name: 'rankingByGeoWorst',
             title: 'widgets.worstGeoLocationsPostventa',
             position: [3, 11],
             size: [1, 2],
             extraConfigs: {
               backgroundColor: '#501C78',
               titleBackgroundColor: '#db7476'
             },
             indicator: 'CSATISD',
             criticalMomentInclude: [getCmID('ISD')],
           }),
           getCommonWidget({
             commonWidgets: commonWidgets,
             name: 'wordCountWithLinks',
             title: 'widgets.wordCount',
             position: [0, 13],
             size: [4, 2],
             criticalMomentInclude: [getCmID('ISD')],
           }),
           getCommonWidget({
             commonWidgets: commonWidgets,
             name: 'textAnalysis',
             title: "widgets.sentimentAnalysis",
             position: [0, 17],
             size: [4, 3],
             indicator: 'SENTIMENT',
             criticalMomentInclude: [getCmID('ISD')],
           }),

    ],
} as DasboardConfig
